module.exports = __webpack_public_path__ + "static/img/home-bg.96d617c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-bg.png
// module id = PGJx
// module chunks = 0